import { useI18n } from '@ecom/i18n';
import {
  Badge,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from '@ecom/ui-kit';
import { type ReactElement } from 'react';

import { StockStateBadge } from '../../products/components/StockStateBadge';
import type { InventoryRow } from '../api';

export function InventoryTable({
  rows,
  onAdjust,
}: {
  rows: readonly InventoryRow[];
  onAdjust: (row: InventoryRow) => void;
}): ReactElement {
  const { t } = useI18n();
  return (
    <Table caption={t('merchant.nav.inventory')}>
      <TableHead>
        <TableRow>
          <TableHeaderCell>{t('merchant.products.table.colProduct')}</TableHeaderCell>
          <TableHeaderCell>{t('merchant.inventory.table.colStockAvailable')}</TableHeaderCell>
          <TableHeaderCell>{t('merchant.inventory.table.colAlertThreshold')}</TableHeaderCell>
          <TableHeaderCell> </TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={`${row.productId}:${row.variantId ?? 'base'}`}>
            <TableCell>
              <div className="flex flex-col">
                <span className="text-sm font-medium text-ink">{row.productName}</span>
                <span className="font-mono text-xs text-inkFaint">{row.sku}</span>
              </div>
            </TableCell>
            <TableCell>
              <StockStateBadge stock={row.stock} />
            </TableCell>
            <TableCell>
              {row.stock.quantityMinThreshold !== null ? (
                <span className="text-sm text-inkFaint">{row.stock.quantityMinThreshold}</span>
              ) : (
                <Badge tone="neutral">{t('merchant.inventory.none')}</Badge>
              )}
            </TableCell>
            <TableCell align="end">
              <Button
                size="sm"
                variant="secondary"
                onClick={() => {
                  onAdjust(row);
                }}
              >
                {t('merchant.inventory.adjust')}
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
